
import Vue from 'vue'

import ProjectModel from '@/views/Project/Project/models/project'

import ModuleSettingsItem from '@/views/Project/Settings/Modules/components/moduleItem.vue'
const ModulesSettingsBody = Vue.extend({
    mixins: [],
    components: { ModuleSettingsItem },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        project: {
            type: ProjectModel,
            required: true,
        },
    },

    data() {
        return {
            loadingView: false,
        }
    },

    computed: {
        modulesAvailableToUser() {
            let arr = [...this.avalableModules]
            arr.filter((item) => {
                return item != 'document'
            })
            return this.isSuperuser
                ? arr
                : arr.filter((item) => {
                      return item != 'document'
                  })
        },
    },

    watch: {
        project: {
            async handler() {
                this.loadingView = true
                await this.project?.get(['modules'])
                this.loadingView = false
            },
            deep: true,
            immediate: true,
        },
    },

    methods: {
        update() {
            this.loadingView = !this.loadingView
            // ModuleSettingsItem watches this property to set the status of the module
        },
    },
})
export default ModulesSettingsBody
